<div class="hold-transition sidebar-mini layout-navbar-fixed layout-footer-fixed">
    <!-- Site wrapper -->
    <div class="wrapper">
        <!-- Navbar -->
        <app-header></app-header>
        <!-- /.navbar -->

        <!-- Main Sidebar Container -->
        <app-sidebar [page]="'users'" [subPage]="'kyc'"></app-sidebar>

        <!-- Content Wrapper. Contains page content -->
        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0">Users</h1>
                    </div><!-- /.col -->
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><a href="#">Home</a></li>
                            <li class="breadcrumb-item"><a [routerLink]="['']">Users</a></li>
                            <li class="breadcrumb-item active">KYC Submission</li>
                        </ol>
                    </div><!-- /.col -->
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->

            <!-- Main content -->
            <section class="content">
                <div class="container-fluid">
                    <app-module-menu [module]="'entities'" [activeSlug]="'kyc'"></app-module-menu>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card card-primary card-outline">
                                <img [hidden]='!loading' [class]="loading?'mx-auto d-block':''" src="assets/LoadingGIF/Rolling-1s-75px.gif">

                                <!-- Default box -->
                                <div class="card card-solid" [hidden]='loading'>
                                    <div class="card-header">
                                        <h3 class="card-title">
                                            <i class="fas fa-edit"></i>
                                            {{mainHeader}}
                                        </h3>
                                        <div class="text-right"> 
                                            <div class="btn-group">
                                                <div class="input-group-sm">
                                                    <input type="text" class="form-control" placeholder="Search Mail">
                                                </div>
                                                <button [routerLink]="['/users/search']" class="btn btn-primary btn-sm" type="button"><i class="fas fa-search"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body table-responsive p-0">
                                        <table class="table table-hover text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th>&nbsp;</th>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Phone</th>
                                                    <th>Country</th>
                                                    <th>Status</th>
                                                    <th>Created</th>
                                                    <th>Last Modified</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let userRow of userist; index as i">
                                                    <th>{{i+1}}</th>
                                                    <td><a [routerLink]="['/users/details', userRow.ref]">{{printName(userRow)}}</a></td>
                                                    <td>{{userRow.email}}</td>
                                                    <td>{{userRow.phone}}</td>
                                                    <td>{{userRow.country.title}}</td>
                                                    <td><span [class]="userRow.status.active === true ? 'badge bg-success' : userRow.status.new === true ? 'badge bg-info' : userRow.status.inactive === true ? 'badge bg-danger' : 'badge bg-warning'" [innerHTML]="userRow.status.active === true ? 'Active' : userRow.status.new === true ? 'KYC Needed' : userRow.status.inactive === true ? 'Inactive' : 'KYC Submitted'"></span></td>
                                                    <td>{{userRow.created}}</td>
                                                    <td>{{userRow.lastModified}}</td>
                                                </tr>
                                                <tr *ngIf="userist.length == 0">
                                                    <td colspan="8" class="text-center">No record to show</td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th>&nbsp;</th>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Phone</th>
                                                    <th>Country</th>
                                                    <th>Status</th>
                                                    <th>Created</th>
                                                    <th>Last Modified</th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <!-- /.card-body -->
                                    <div class="card-footer" *ngIf="userist.length > 0">
                                        <app-pagination [url]='url' [counts]='count'(refresh)="getUserKyc($event)"></app-pagination>
                                    </div>
                                    <!-- /.card-footer -->
                                </div>
                            </div>
                        <!-- /.card -->
                        </div>
                        <!-- /.col -->
                    </div>
                <!-- /.row -->
                </div><!-- /.container-fluid -->
            </section>
            <!-- /.content -->
            <!-- /.content-wrapper -->

        </div>
        <!-- /.content-wrapper -->
        <app-footer></app-footer>
    </div>
    <!-- ./wrapper -->
</div>
